import React from "react"
import { withFormik, FormikProps, Form } from "formik"
import { styled } from "@mui/material"
import { buttonClasses } from "@mui/base/Button"

import Button from "components/ui/Button"
import { SubscriptionPaymentFormValues } from "types"

interface FormProps {
  initialValues: {
    bank_name: string
  }
  title: string
  color: string
  disabled: boolean
  onSubmit: (values: SubscriptionPaymentFormValues) => void
}

type Props = FormikProps<SubscriptionPaymentFormValues> & FormProps

const SubscriptionPaymentForm = ({ title, color, disabled }: Props) => {
  return (
    <Wrapper>
      <Submit type="submit" color={color} disabled={disabled}>
        {title}
      </Submit>
    </Wrapper>
  )
}

const SubscriptionPaymentFormWithFormik = withFormik<
  FormProps,
  SubscriptionPaymentFormValues
>({
  enableReinitialize: true,
  mapPropsToValues: ({ initialValues }) => initialValues,
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values),
})(SubscriptionPaymentForm)

export default SubscriptionPaymentFormWithFormik

const Wrapper = styled(Form)`
  margin: 16px 10px;
  max-width: 150px;
`

const Submit = styled(Button)`
  border: none;
  background-color: #f2f2f2;
  border-radius: 21.5px;
  flex-basis: 50%;
  height: 43px;
  width: 150px;

  &.${buttonClasses.root} {
    color: ${({ color }) => color};
  }
`
